/** @jsx h */
import { h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import FullCardContainer from './Container'
import InfiniteModal from '../InfiniteModal'
import OrganizationCard from './OrganizationCard'
import StoryCardListForInfiniteModal from './stories/StoryCardListForInfiniteModal'
import AboutCardForInfiniteModal from './about/AboutCardForInfiniteModal'

const NESTED_CARDS_SELECTOR = '.InfiniteModal > article:not(:first-of-type)'
const SLIDE_ANIMATION_END_CLASS = 'InfiniteModal--slideOut'

/**
 * OrganizationCard that can display ProofPoint
 */
const FullOrganizationCard = ({
  data,
  data: { claims, aboutTip },
  journeys
}) => {
  const [proofPointId, setProofPointId] = useState(0)
  const [openStoryIndex, setStoryOpen] = useState(-1)
  const [openAboutIndex, setAboutOpen] = useState(-1)

  const selectedProofPoint =
       (claims || []).find(({ id }) => id === proofPointId)

  const openProofPointAside = proofPointId => {
    setProofPointId(proofPointId)
  }

  const openStory = idx => e => {
    setStoryOpen(idx)
  }

  const closeStory = idx => e => {
    setStoryOpen(-1)
  }

  const openAbout = idx => e => {
    setAboutOpen(idx)
  }

  const closeAbout = idx => e => {
    setAboutOpen(-1)
  }

  const isStoryOpen = openStoryIndex > -1
  const isAboutOpen = openAboutIndex > -1

  const slideOut = _clickEvent => {
    const el = document.querySelector(NESTED_CARDS_SELECTOR)
    el.classList.add(SLIDE_ANIMATION_END_CLASS)
  }

  const onSlideAnimationEnd = event => {
    if (event.target.classList.contains(SLIDE_ANIMATION_END_CLASS)) {
      setProofPointId(0)
    }
  }

  useEffect(() => {
    window.addEventListener('animationend', onSlideAnimationEnd)
    return () => window.removeEventListener('animationend', onSlideAnimationEnd)
  }, [])

  return (
    <InfiniteModal class={`
    ${isStoryOpen ? 'InfiniteModal--revealStory' : 'InfiniteModal--concealStory'}
    ${selectedProofPoint ? 'InfiniteModal--slideIn' : ''}
    ${isAboutOpen ? 'InfiniteModal--slideIn' : ''}
    `}
    >
      <OrganizationCard {...data} journeys={journeys} onStoryClick={openStory} onProofPointClick={openProofPointAside} onAboutClick={openAbout} />

      {selectedProofPoint && [
        <FullCardContainer data={{ ...selectedProofPoint, onStoryClick: openStory }} fullCard={false} key='FullCardContainer' />,
        <InfiniteModal.Back onClick={slideOut} key='InfiniteModal.Back' />
      ]}

      <StoryCardListForInfiniteModal journeys={journeys} openStoryIndex={openStoryIndex} closeStory={closeStory} />
      <AboutCardForInfiniteModal aboutTip={aboutTip} reveal={isAboutOpen} closeAbout={closeAbout} />
    </InfiniteModal>
  )
}

export default FullOrganizationCard
